// @flow
import * as React from 'react';

import { Link } from 'react-router-dom';

import type { Organization } from '@gandi/redux-organization';
import { useTranslator, type TranslatorProps } from '@gandi/translate';

import withOwnerProps, { type OwnerProps, type OwnProps } from './withProps';

export type Props = {
  ...OwnProps,
  ...OwnerProps,
};

const paddingRight = { paddingRight: '1em' };
const getTranslation = (__: TranslatorProps['__'], ownerName: string) =>
  __('%(ownerName)s will be the owner of all these new domains.', {
    ownerName,
  });

function getOrgDisplayName(org: ?Organization) {
  if (!org) {
    return null;
  }

  if (org.type === 'individual') {
    /** $FlowFixMe if org.type is individual, firstname and lastname will be defined */
    return `${org.firstname} ${org.lastname}`;
  }

  return org.orgname || org.name;
}

function DomainOwnerRowContents(props: Props): React.Node {
  const {
    cartId,
    currentOrganization,
    productOwner,
    productOwnerOrg,
    product,
    cartCustomer,
  } = props;

  const { __ } = useTranslator();

  const accountChoiceLink = `/cart/${cartId}/configure/account-choice`;

  // $FlowFixMe[prop-missing] FIXME: not the same Organization, one is from `redux-sharing` the other from `redux-organization` libs
  let ownerName = getOrgDisplayName(currentOrganization);

  // Fallback for a reseller buying a product for a customer.
  // In case `payload.owner_name` hasn't been correctly set.
  if (currentOrganization?.reseller && cartCustomer) {
    ownerName = __('Your customer');
  }

  // Set by account-choice in case of a reseller buying for a customer.
  if (product?.payload.owner_name) {
    ownerName = product.payload.owner_name;
  }

  // Case of buying for someone else.
  if (productOwner) {
    ownerName = getOrgDisplayName(productOwnerOrg) || productOwner;
  }

  // XXX: what if `ownerName` is undefined?

  return (
    <>
      {/* $FlowFixMe[incompatible-call] */}
      <span style={paddingRight}>{getTranslation(__, ownerName)}</span>
      <Link to={accountChoiceLink}>{__('Change')}</Link>
    </>
  );
}

export default (withOwnerProps(
  DomainOwnerRowContents,
): React.ComponentType<OwnProps>);
